import { RichUnit } from "../models/AttendanceUnit";
import { catalogoApi } from "../services/api";

// docs: https://catalog-svc-dev.telemedicinaeinstein.com.br/docs/
export const fetchBranches = async (limit: number) => {
  const response = await catalogoApi.get("branch", {
    params: { limit },
  });

  const { data } = response;
  return data.data as  RichUnit[];
};

export const fetchBrancheById = async (id: string) => {
  const response = await catalogoApi.get(`branch/${id}`);
  const { data } = response;
  return data;
};
